import React from 'react';
import { withStyles, Grid, withRouter, ButtonBase } from '../../material-ui';
import Match from '../../model/Match';
import DateUtils from '../../control/dateutils';
import './home.css'
import AppData from '../../model/AppData';
import ToName from '../../control/ToName';
import AppUtils from '../../control/apputlis';
import Apis from '../../network/Apis';
import AppConfig from '../../control/config';

const ICON_ZHIBO = require("../../images/icons/zhibo.gif");



class LiveContent extends React.Component {

    toPlay = async (data) => {
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.match_type ? data.match_type : 0;
        let match_id = data.match_id ? data.match_id : 0;
        if (match_id == 0) {
            match_id = data.id;
        }
        if (match_type == 0) {
            match_type = data.type_id
        }

        let result = await Apis.encryptionJumpToRoom(match_type, match_id);
        console.log("toPlay:" + result);
        if (result.code == 200) {
            if (result.data != 0) {
                room_id = result.data
            }
        }

        let os = 0;
        if (AppData.os !== '') {
            os = AppData.os
        }
        let token = 0;

        if (AppData.me.token !== '') {
            token = AppData.me.token
        }

        let customerId = 0
        if (AppData.me.customer_id && AppData.me.customer_id != 0 && AppData.me.customer_id != '') {
            customerId = AppData.me.customer_id
        }
        let uid = AppUtils.getStorageItem('uid');
        let fastkey = AppUtils.getStorageItem("fastkey");
        let roomIp = AppUtils.getStorageItem("roomIp");
        let roomPort = AppUtils.getStorageItem("roomPort");
        let channel = AppUtils.getStorageItem("channel");
        if (!channel) {
            channel = AppConfig.channelid
        }
        let fid = AppData.me.free_id

        ToName(this.props, `/play/${room_id}/${match_type}/${match_id}/${uid}/${fastkey}/${roomIp}/${roomPort}/${os}/${token}/${customerId}/${fid}/${channel}`, data)

    }

    render() {
        const { classes, data, index } = this.props;
        let match = new Match(data);
        let homeScore = match.getHomeScore();
        let away_scores = match.getAwayScore();
        let isLiving = match.living();
        let str = homeScore + ' : ' + away_scores;
        // console.log('isLiving',isLiving);
        //是否正在直播
        if (!isLiving) {
            str = DateUtils.dateFormatHM(match.match_time * 1000);
        }
        return (
            <ButtonBase onClick={() => this.toPlay(match)} >
                <Grid container direction='column' alignItems='center' className={classes.root}>

                    <div className='homerowBox'>
                        <div className='siTitle'>
                            {data.short_name_zh}
                        </div>
                        <div className='redbor' >
                            <img src={ICON_ZHIBO}></img>
                        </div>
                    </div>
                    <div className='qiuinfu' >
                        <div className='qiuinfuitem'>
                            <img src={data.home_log} className={classes.icon} />
                            <div className='homecontentText' >{data.home_name}</div>
                        </div>
                        <div className='homeScore'>{homeScore}</div>
                    </div>
                    <div className='qiuinfu' style={{ marginTop: 10 }}>
                        <div className='qiuinfuitem'>
                            <img src={data.away_log} className={classes.icon} />
                            <div className='homecontentText' >{data.away_name}</div>
                        </div>
                        <div className='homeScore'>{away_scores}</div>
                    </div>

                </Grid>
            </ButtonBase>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: 160,
        height: 105,
        backgroundColor: '#EFEFF4',
        borderRadius: 8,
        paddingLeft: 10,
        paddingRight: 10
    },
    title: {
        color: '#0D0D0D',
        fontSize: 12,
    },
    liveText: {
        color: '#FB0000',
        fontSize: 9,
        margin: theme.spacing(0, 1, 0, 1),
    },
    scoreText: {
        color: '#0D0D0D',
        fontSize: 14,
        fontWeight: 'bold'
    },
    livingText: {
        fontSize: 9,
        color: '#FF7D0A'
    },
    titleContainer: {
        width: '100%',
    },
    infoContainer: {
        flex: 0.24
    },
    content: {
        flex: 0.37
    },

    icon: {
        width: 22,
        height: 22,
        borderRadius: 15,
        backgroundColor: '#FFF'
    },
    playIcon: {
        width: 10,
        height: 10,
        margin: theme.spacing(0, 1.5, 0, 0),
    },
    bottom: {
        flex: 0.37
    },
    hot: {
        width: 32,
        height: 15,
        marginRight: theme.spacing(1)
    }

}))(LiveContent));